import { Injectable } from '@angular/core';

/**
 * The `ScriptService` provides utilities for managing external JavaScript libraries
 * provided by third-party vendors.
 * 
 * This service is particularly useful for dynamically loading and managing external
 * scripts within an Angular application.
 */

@Injectable({
  providedIn: 'root'
})
export class ScriptService {
  private loadedLibs: { [url: string]: { loaded: boolean, type: string } } = {};

  constructor() {
    // this.loadScriptsFromStorage();

  }

  // private loadScriptsFromStorage(): void {
  //   const scripts = JSON.parse(localStorage.getItem('loadedScripts') || '{}');
  //   Object.keys(scripts).forEach( purposeuri => {
  //     const scriptInfo = scripts[purposeuri];
  //     if (scriptInfo.loaded) {
  //       this.injectLib(purposeuri, scriptInfo.src, scriptInfo.type).catch(console.error);
  //     }
  //   });
  // }

  // private saveScriptsToStorage(): void {
  //   try {
  //     localStorage.setItem('loadedScripts', JSON.stringify(this.loadedLibs));
  //   } catch( e) {
  //     console.log( `exception in localStorage.setItem: ${e}`);
  //   }
  // }
  

/**
 * 'injectLib' dynamically injects an external JavaScript library into the document.
 * 
 * This method facilitates the dynamic loading of an external JavaScript library,
 * provided by a third-party vendor, into the document. Once loaded, the library
 * becomes accessible for use within the application.
 * 
 * @param src The URL of the external JavaScript library to be injected.
 * @param resourceType The MIME type of the resource. Use 'module' for ES6 modules
 *                     or 'application/javascript' for scripts that provide a global
 *                     variable attached to the window object.
 * @returns A promise that resolves when the library has been successfully loaded,
 *          or rejects if an error occurs during loading.
 */

  async injectLib(src: string, resourceType: string) {
    if (this.loadedLibs[src]?.loaded) {
      return; // Already loaded
    }

    const script = document.createElement('script');
    script.type = resourceType;
    script.src = src;

    return new Promise<void>((resolve, reject) => {
      script.onload = (event) => {
        this.loadedLibs[src] = { loaded: true, type: resourceType };
  //      this.saveScriptsToStorage();
        resolve();
      };
      script.onerror = (event) => {
        reject();
      };

      document.body.appendChild(script);
    });
  }

  /**
   * 'destroyLib' dynamically removes an external JavaScript library from the document.
   * 
   * This method aims to reverse the effects of `injectLib` by removing the script element
   * from the DOM. It is designed to help manage the removal of scripts that are no longer
   * needed, potentially reducing resource consumption and preventing memory leaks. However,
   * it's important to note that removing a script element does not automatically undo all
   * the changes made by the script (such as global variables or event listeners). Manual
   * cleanup of these changes may be necessary.
   * 
   * @param src The URL of the external JavaScript library to be removed.
   * @returns void This method does not return a value but logs a warning if the script is
   *         not found or already removed.
   */
  destroyLib(src: string): void {
    if (!this.loadedLibs[src]?.loaded) {
      console.warn(`Library not loaded or already destroyed: ${src}`);
      return;
    }

    // Attempt to locate and remove the script element from the document
    const script = document.querySelector(`script[src="${src}"]`);
    if (script) {
      document.body.removeChild(script);
    }

    // Optionally, clean up any known global variables or other modifications made by the script
    // This could be complex and is specific to what the script does
    // Example: if the script adds `window.myLib`, you might want to do `delete window.myLib`;

    delete this.loadedLibs[src];
    // this.saveScriptsToStorage();
  }
}
